import React, { useState, useEffect, useCallback } from 'react';
import { Button, Form, Select } from 'semantic-ui-react';
import * as CONSTANTS from '../constants/constants';
import * as URLMAPPING from '../config/UrlMapping';
import { parseRoleSearch } from '../utils/parseRoles'
import _ from "lodash"


export default function AddPermissionToRoleCmp(props) {


    const initialState = {
        role: {name: 'role', type: 'input', value : '', label: 'Role', pattern: '', isInvalid: false, required: false},
    }
 

    const [component, setComponent] = useState(initialState);

    const [roles] = useState([]);       

    const [permissionsRows, setPermissionssRows] = useState([]);
    const [permissions] = useState([]);       

    const [searched, setSearched] = useState(false);

    const addPermisionToRole = (id) => {
        let payload = {roleId: component.role.value, permissionId: id}
        
        document.getElementById('permissions-button-add-' + id).classList.add("disabled");
        document.getElementById('permissions-button-delete-' + id).classList.remove("disabled");
        
        props.addPermisionToRole(payload)
    }

    const deletePermisionToRole = (id) => {
        let payload = {roleId: component.role.value, permissionId: id}

        document.getElementById('permissions-button-delete-' + id).classList.add("disabled");
        document.getElementById('permissions-button-add-' + id).classList.remove("disabled");
        props.deletePermisionToRole(payload)
    }

    
    const setRow = useCallback((id, description) =>{
        
        let retorno =  
                (<tr key={id}>
                   <td data-label='Id'>{id}</td>
                   <td data-label='Descripción'>{description}</td>        
                   <td> 
                       <Button size='small' id={'permissions-button-add-'+id} className={'disabled'} onClick={()=>addPermisionToRole(id)} type='button'>ADD</Button>
                       <Button size='small' id={'permissions-button-delete-'+id} className={'disabled'} onClick={()=>deletePermisionToRole(id)} type='button'>REMOVE</Button>
                   </td> 
               </tr>
               )
        return retorno;
    },[permissions])
    
    const setRowError = useCallback((error) =>{
        return  <tr key={1}>
                    <td >{error}</td>
                </tr>
    }, [])

    const redirectToLogin = useCallback(() =>{
        props.history.push(URLMAPPING.LOGIN)
    },[props.history])

    const parseRequests = useCallback(()=>{
        let array = [];
        if(props.permissions)
        props.permissions.forEach(element=>{
          array.push(setRow(
              element.id,
              element.description
          ))
        })
        
        if(array[0] === undefined){
            let error = 'No se encontraron registros'
            
            array.push(setRowError(error))
        }
    
        setPermissionssRows(array);
    }, [props, setRow, setRowError]);

    const handleChange = (event, callbackPost) => {
        if(event === undefined){
          return;
        }
    
        let targetName=event.target.name;
        let targetValue=event.target.value;
        var newComponent = component;
        newComponent[targetName].value = targetValue;
        newComponent[targetName].error = undefined;
        setComponent(prevState => ({ ...prevState, [targetName]: newComponent[targetName] }));
        if (typeof callbackPost === "function")
        callbackPost(targetValue, targetName);
    }
    
    const fetchRolePermissions = (id) => {
        setSearched(true)
        props.getListRolePermissions(id);
    }
    
    const disableButtonsAdded = () => {
        //document.getElementById("permissions-button-add-"+id).disabled = true;
        if(props.rolePermissions)

        props.permissions.forEach((elem1)=>{

            //document.getElementById('permissions-button-delete-' + elem1.id).disabled = false;
            document.getElementById('permissions-button-delete-' + elem1.id).removeAttribute("disabled");
            document.getElementById('permissions-button-delete-' + elem1.id).classList.remove("disabled");
            
            //document.getElementById('permissions-button-add-' + elem1.id).disabled = false;
            document.getElementById('permissions-button-add-' + elem1.id).removeAttribute("disabled");
            document.getElementById('permissions-button-add-' + elem1.id).classList.remove("disabled");
            
            
            
            let includes = _.find(props.rolePermissions, (elem2)=>{
                return elem1.id === elem2.id;
            })
            let disabled = false;
            if(includes){
                // console.log("includes",includes)
                disabled = true;
            }
            //console.log("permissions-button-add-"+elem1.id)
            if(disabled){
                document.getElementById('permissions-button-add-' + elem1.id).classList.add("disabled");
            }
            else{
                document.getElementById('permissions-button-delete-' + elem1.id).classList.add("disabled");
                
            }
                
        })
        
    }
    
    useEffect(() => {

        if(props.roles === undefined && props.rolesStatus !== CONSTANTS.LIST_ROLES_GET_LOADING && props.rolesStatus !== CONSTANTS.LIST_ROLES_GET_ERROR){
            props.getListRoles();
        }

        if(roles[0] === undefined && props.roles !== undefined) { 
            parseRoleSearch(roles, props.roles, {id: 'id', value: 'id', text: 'description'});
        }
        
        if(props.permissions !== undefined && props.permissionsStatus !== CONSTANTS.LIST_PERMISSIONS_GET_LOADING && props.permissionsStatus !== CONSTANTS.LIST_PERMISSIONS_GET_ERROR){
            parseRequests();
        }
        
        if(props.permissions === undefined && props.permissionsStatus !== CONSTANTS.LIST_PERMISSIONS_GET_LOADING && props.permissionsStatus !== CONSTANTS.LIST_PERMISSIONS_GET_ERROR){
            props.getListPermissions();
        }

        if(props.permissions !== undefined && props.permissionsStatus !== CONSTANTS.LIST_PERMISSIONS_GET_LOADING && props.permissionsStatus !== CONSTANTS.LIST_PERMISSIONS_GET_ERROR){
            parseRequests();
        }
        
        if(searched && props.rolePermissions !== undefined 
            && props.rolePermissionsStatus !== CONSTANTS.LIST_ROLES_PERMISSIONS_ADD_LOADING
            && props.rolePermissionsStatus !== CONSTANTS.LIST_ROLES_PERMISSIONS_ADD_ERROR
            && props.rolePermissionsStatus !== CONSTANTS.LIST_ROLES_PERMISSIONS_GET_LOADING 
            && props.rolePermissionsStatus !== CONSTANTS.LIST_ROLES_PERMISSIONS_GET_ERROR){
            disableButtonsAdded();
            setSearched(false)
        }

    },[props, parseRequests])

    return (
        <div>
            <div className={'section-title'}>Elegir Role</div>
            <React.Fragment>
                <Form className='form-large'>
                    <Form.Group widths='equal'>

                        <Form.Field
                            control={Select}
                            options={roles}
                            value={component.role.value}
                            placeholder={component.role.label}
                            name={component.role.name}
                            label={component.role.label}
                            onChange={(e, o)=>handleChange({target:{name :component.role.name, value: o.value}}, fetchRolePermissions)}
                            error={component.role.error}
                        />
                        
                        {/* <Button size='small' fluid className={'boton-ver-coberturas'} onClick={()=>getList()} type='button'>Buscar</Button> */}
                    </Form.Group>
                </Form>
            </React.Fragment>
            <div className='container'>
                <div className={'section-title'}>Listado Permisos</div>
                {<table className='ui celled table'>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Descripcion</th>
                            <th>Agregado</th>
                        </tr>
                    </thead>
                    <tbody className="tbody-list">
                        {permissionsRows}
                    </tbody>
                    </table>}
            </div>
        </div>
    )
}